import ThreeDotMenu from "app/components/threeDotMenu";
import { COMMON_ACCESS_ACTION } from "../../../../../../../../constants";
import { showAlertBox } from "middleware/actions/alertBoxAction";
import { setProductDetails } from "middleware/actions/productAction";
import { actionError, actionSuccess } from "middleware/actions/utilityAction";
import { deleteProductImage, fetchProductBasicById, fetchProductImageUrl } from "middleware/services/productApi";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactTooltip from "react-tooltip";
import { accessRightActionCheck } from "utilities";
import { Box } from "@mui/material";

const ImageTable = (props) => {
  const [sortedImagesList, setSortedImagesList] = useState([]);
  const { productId } = props.computedMatch.params || {};
  const split_url = props.location.pathname.split("/");
  split_url.pop();
  const { accessRights: aR } = props;
  const dispatch = useDispatch();
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);
  const history = useHistory();

  useEffect(() => {
    let interfaceName = "Overview";
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, []);

    /* Common access */
  const accessPermissionAdd = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.ADD_IMAGES);
  const accessPermissionDelete = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.DELETE_IMAGES);

  const getProductDetails = async () => {
    try {
      const response = await fetchProductBasicById(productId);
      if (response?.data?.data) dispatch(setProductDetails(response.data.data));
    } catch (error) {
      dispatch(actionError("Something Went Wrong while processing."));
    }
  };

  const deleteImage = async (id) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          try {
            await deleteProductImage(productId, id);
            dispatch(actionSuccess("Image deleted successfully."));
            await getProductDetails();
          } catch (error) {
            dispatch(actionError("Something went wrong."));
          }
        },
      })
    );
  };

  // Sort imagesList by latest modified or created date (descending)
  useEffect(() => {
    const sortedList = (props?.imagesList || []).slice().sort((a, b) => {
      const dateA = new Date(a?.imgModifiedDate || a?.imgCreatedDate);
      const dateB = new Date(b?.imgModifiedDate || b?.imgCreatedDate);
      return dateB - dateA;
    });
    setSortedImagesList(sortedList);
  }, [props?.imagesList]);

  return (
      <Box>
        <table className="normal-table table table-bordered">
          <thead className="internal-grid">
            <tr>
              <th>Document</th>
              <th className="text-center internal-grid-action" style={{ width: "5%" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedImagesList.map((item) => {
              return (
                <React.Fragment key={`prod-video-${item.id}`}>
                  <tr>
                    <td>
                      <a href={fetchProductImageUrl(item.imgFileName, item.imgName)} download target="_blank">
                        <img src="/assets/download-icon.svg" alt="image-download" /> {item.imgName}
                      </a>
                      <ReactTooltip />
                    </td>
                    <td className="text-center">
                      {accessPermissionAdd || accessPermissionDelete ? (
                        <ThreeDotMenu
                          rowID={item.id}
                          Edit={
                            accessPermissionAdd
                              ? () => {
                                  history.push(`${split_url.join("/")}/image/${item.id}/edit#overview`, {
                                    companyId: props?.companyId,
                                    productId: props?.productId,
                                    imageId: item.id,
                                  });
                                }
                              : undefined
                          }
                          Delete={
                            accessPermissionDelete
                              ? () => {
                                  deleteImage(item.id);
                                }
                              : undefined
                          }
                        />
                      ) : null}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </Box>
  );
};

export default ImageTable;
